module.exports = __webpack_public_path__ + "front/img/bg_r.e6897640.png";